import { ALL_PERMISSIONS } from './permission';

import type { Permission } from './permission';
import type { PlatformRole } from '../identity/role';

/**
 * Baseline RBAC matrix. Seeded into the database on first boot; the server is
 * authoritative at runtime and returns each session's effective permissions.
 * This copy powers the Admin Portal grid, local development, and tests.
 */

const CONSULTANT_PERMISSIONS: readonly Permission[] = [
  'dashboard.view',
  'project.view',
  'analysis.view',
  'analysis.run',
  'analysis.fitgap.edit',
  'analysis.scope.generate',
  'analysis.scope.edit',
  'analysis.scope.rephrase',
  'analysis.scope.sendToTsg',
  'analysis.checklist.generate',
  'analysis.checklist.edit',
  'testScript.view',
  'testScript.generate',
  'testScript.download',
  'testScript.email',
  'assistant.use',
];

/**
 * Project Manager is read-only across the AI modules but retains the Scope
 * Items approval gate — the delivery owner signs off work they did not author.
 * `project.viewAll` lifts the assigned-projects filter for the whole portfolio.
 */
const PROJECT_MANAGER_PERMISSIONS: readonly Permission[] = [
  'dashboard.view',
  'project.view',
  'project.viewAll',
  'project.create',
  'project.edit',
  'project.delete',
  'project.timeline.edit',
  'project.tasks.manage',
  'project.members.manage',
  'analysis.view',
  'analysis.scope.approve',
  'testScript.view',
  'assistant.use',
];

/** Read-only observer today; the SDS validation gate arrives with that module. */
const QCS_PERMISSIONS: readonly Permission[] = [
  'dashboard.view',
  'project.view',
  'analysis.view',
  'testScript.view',
  'assistant.use',
];

export const DEFAULT_ROLE_PERMISSIONS: Readonly<Record<PlatformRole, readonly Permission[]>> = {
  platform_admin: ALL_PERMISSIONS,
  project_manager: PROJECT_MANAGER_PERMISSIONS,
  functional_consultant: CONSULTANT_PERMISSIONS,
  // Identical to Functional today, held as a separate record so the two can
  // diverge later without a code change.
  technical_consultant: CONSULTANT_PERMISSIONS,
  qcs_consultant: QCS_PERMISSIONS,
};
